import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { createContext } from "use-context-selector";
import { isMobile } from "react-device-detect";
const ThemeContext = createContext();
export default ThemeContext;

export const ThemeProvider = ({ children }) => {
  const location = useLocation();
  const [theme, setTheme] = useState("dark");
  const [cssLoaded, setCssLoaded] = useState(false);
  let light = "v-application v-application--is-ltr theme--light";
  let dark = "v-application v-application--is-ltr theme--light";
  const bodyClassname = theme === "light" ? light : dark;
  const prevRouteGroupRef = useRef(null);
  const getRouteGroup = (pathname) => {
    const route = pathname?.split("/")[1];

    if (
      [
        "sports-velki",
        "match-detail-velki",
        "league-velki",
        "favourite-velkie",
        "exchange-velki",
      ].includes(route)
    ) {
      return "VELKI";
    }

    if (
      [
        "sports-sky",
        "match-detail-sky",
        "inplay-sky",
        "horse-racing-sky",
        "favourite-sky",
        "sports-sky-new",
        "account-sky",
        "exchange",
        "result-sky",
      ].includes(route)
    ) {
      return "SKY";
    }

    return "DEFAULT";
  };

  useEffect(() => {
    const loadCss = async () => {
      const currentGroup = getRouteGroup(location.pathname);

      // 🚀 EXIT EARLY: same group → no CSS reload
      if (prevRouteGroupRef.current === currentGroup) {
        return;
      }

      prevRouteGroupRef.current = currentGroup;
      setCssLoaded(false);

      // cleanup
      document
        .querySelectorAll("link[data-theme]")
        .forEach((link) => link.remove());
      localStorage.setItem("theme", theme);

      const addStylesheet = (href) =>
        new Promise((resolve, reject) => {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          link.href = href;
          link.setAttribute("data-theme", theme);
          link.onload = resolve;
          link.onerror = () => reject(`❌ Failed: ${href}`);
          document.head.appendChild(link);
        });

      if (currentGroup === "DEFAULT") {
        document.body.className = bodyClassname;

        const themePromises = [
          ...(isMobile
            ? [
                "/assets/css/mobile/style2.css",

                "/assets/css/mobile/materialIcon.css",
                "/assets/css/mobile/style.css",
                "/assets/css/mobile/style4.css",
                "/assets/css/spin.css",
                "/assets/css/mobile/style3.css",
              ]
            : [
                "/assets/css/web/style2.css",
                "/assets/css/web/style3.css",
                "/assets/css/web/materialIcon.css",
                "/assets/css/web/style.css",
                "/assets/css/web/style4.css",
                "/assets/css/web.css",
                "/assets/css/spinWeb.css",
              ]),
        ].map(addStylesheet);

        await Promise.all(themePromises);
      } else if (currentGroup === "VELKI") {
        if (!isMobile) {
          document.body.className = "is-desktop";
        }
        document.documentElement.className =
          "canvas webgl supports csstransforms csstransforms3d avif apng webp s-webp no-jpeg2000 webp-animation webp-alpha webp-lossless";
        document.documentElement.style.setProperty(
          "--root-font-size",
          isMobile ? "3.7333333333333334vw" : "17.92px",
        );

        const themePromises = [
          "/assets/css/icomoon.css",
          "/assets/css/velkie/velkieMedia.css",
          "/assets/css/velkie/velkie.css",
        ].map(addStylesheet);
        await Promise.all(themePromises);
      } else if (currentGroup === "SKY") {
        let themePromises = [];
        if (isMobile) {
          themePromises = [
            "/assets/css/icomoon.css",
            ["exchange"].includes(location.pathname?.split("/")[1])
              ? "/assets/css/sky/web.css"
              : isMobile
                ? "/assets/css/sky/sky.css"
                : "/assets/css/sky/web.css",
          ].map(addStylesheet);
        } else {
          themePromises = ["/assets/css/sky/web.css"].map(addStylesheet);
        }
        await Promise.all(themePromises);
      }
      setCssLoaded(true);
    };

    loadCss().catch(console.error);
  }, [theme, location.pathname]);

  const toggleTheme = () => {
    setCssLoaded(false);
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, cssLoaded }}>
      {/* {![
        "sports-velki",
        "match-detail-velki",
        "league-velki",
        "sports-sky",
        "inplay-sky",
        "match-detail-sky",
        "horse-racing-sky",
        "favourite-velkie",
        "favourite-sky",
        "sports-sky-new",
        "account-sky",
        "exchange",
        "exchange-velki",
      ].includes(location.pathname?.split("/")[1]) && (
        <AnimatePresence mode="wait">
          {!cssLoaded && (
            <motion.div
              key="loader"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
              className="fixed inset-0 z-50 flex items-center justify-center bg-white"
            >
               <div
            className="v-overlay v-overlay--active theme--light"
            style={{ "z-index": "300" }}
          >
            <>
              <div
                className="v-overlay__scrim"
                style={{
                  opacity: "0.8",
                  "background-color": "rgb(33, 33, 33)",
                  "border-color": "rgb(33, 33, 33)",
                }}
              />{" "}
              <div class="v-overlay__content">
                <div class="pulse">
                  <img
                    src="/assets/images/bigtaka_logo.png"
                    width="120"
                    height="120"
                  />
                </div>
              </div>{" "}
            </>
          </div>
            </motion.div>
          )}
        </AnimatePresence>
      )} */}

      {/* ✅ children not keyed → no remount/double render */}

      {children}
    </ThemeContext.Provider>
  );
};
